// extracted by mini-css-extract-plugin
export default {"pButtonLabel":"styles_pButtonLabel__HcD8K"};